import type { RUMEntry } from "@fiverr-private/relay-sdk";
import { coordinatesString } from "../coordinatesString";
import { describe } from "../describe";
import { entryCoordinates } from "../entryCoordinates";
import { blockingTimeAccumulator } from "../blockingTimeAccumulator";

const accumulators = [blockingTimeAccumulator.accumulate];

const counters = new Map<string, number>();

export function processEntry(entry: PerformanceEntry): RUMEntry {
    if (!entry) {
        return;
    }

    const counter = entry.counter || (counters.get(entry.entryType) || 0) + 1;
    counters.set(entry.entryType, counter);

    accumulators.reduce((entry, fn) => fn(entry), entry);

    if (entry.entryType === "longtask") {
        return undefined;
    }

    const target = getTarget(entry);
    const coordinates = entryCoordinates(entry);
    const _mergeable = ["navigation", "mark", "paint"].includes(
        entry.entryType,
    );
    return { counter, target, coordinates, ...entry.toJSON?.(), _mergeable };
}

/**
 * Create a string descriptor of the target of this entry
 */
function getTarget(entry: PerformanceEntry): string {
    // event, first-input or superimposed largest-contentful-paint
    if (entry.target) {
        return describe(entry.target);
    }

    // largest-contentful-paint
    if (entry.element) {
        return describe(entry.element);
    }

    // layout-shift
    if (Array.isArray(entry.sources)) {
        return entry.sources
            .map(({ node, previousRect, currentRect }) =>
                [
                    node && describe(node),
                    node && ": ",
                    previousRect ? coordinatesString(previousRect) : "Nothing",
                    " => ",
                    coordinatesString(currentRect),
                ]
                    .filter(Boolean)
                    .join(""),
            )
            .join(", ");
    }
}
